function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("path", {
  d: "M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"
})));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

const SvgRightArrow = (_ref) => {
  let {
    svgRef,
    ...props
  } = _ref;
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "Layer_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 492.004 492.004",
      style: {
        enableBackground: "new 0 0 492.004 492.004"
      },
      xmlSpace: "preserve",
      ref: svgRef
    }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17)
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgRightArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/right-arrow.be237328.svg";
export { ForwardRef as ReactComponent };